export default "__VITE_ASSET__BbBR4q01__"